import { render, staticRenderFns } from "./StuckCases.vue?vue&type=template&id=2c0bf74e&"
import script from "./StuckCases.vue?vue&type=script&lang=js&"
export * from "./StuckCases.vue?vue&type=script&lang=js&"
import style0 from "./StuckCases.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports